import types, {
  CLEAR_PIN_PASSWORD,
} from "../../actions/digitalCertificateActions/types";
import { FETCH_STATUS } from "../../../constants/index";

export const digitalCertificate = (
  state = {
    data: [],
    status: FETCH_STATUS.NOT_LOADED,
    error: "",
  },
  action
) => {
  const { payload: { data, error } = {} } = action;
  switch (action.type) {
    case types.FETCH_CERTIFICATE_REQUEST:
      return {
        ...state,
        status: FETCH_STATUS.LOADING,
        error: null,
      };
    case types.FETCH_CERTIFICATE_SUCCESS:
      return {
        ...state,
        data: data,
        status: FETCH_STATUS.LOADED,
      };
    case types.FETCH_CERTIFICATE_FAILURE:
      return {
        ...state,
        status: FETCH_STATUS.FAILED,
        error,
      };
    case CLEAR_PIN_PASSWORD:
      return {
        data: {},
        status: FETCH_STATUS.NOT_LOADED,
      };
    default:
      return state;
  }
};

export default digitalCertificate;
